let instance: URLSearchParams;
export const getUrlSearchParam = () => {
  if (instance) return instance;
  if (!global.window) return;
  instance = new URLSearchParams(window.location.search);

  return instance;
};
